// api.js
import axios from 'axios';

// console.log('Base URL:', process.env.NODE_ENV);

const BASE_URL = `${process.env.VUE_APP_API_BASE_URL}/api`;
const api = axios.create({
  baseURL: BASE_URL,
});

api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('jwt');
    if (token && !config.headers['Content-Type']) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Helper functions for protected and unprotected API calls
export async function callProtectedApi(endpoint, method = 'get', data = null, options = {}) {
  return api({
    url: endpoint,
    method: method.toLowerCase(),
    data,
    ...options, // Merge additional options (e.g., responseType)
  });
}

export async function callUnprotectedApi(endpoint, method = 'get', data = null, options = {}) {
  const unprotectedApi = axios.create({
    baseURL: BASE_URL,
  });

  return unprotectedApi({
    url: endpoint,
    method: method.toLowerCase(),
    data,
    ...options, // Merge additional options (e.g., responseType)
  });
}

export default { callProtectedApi, callUnprotectedApi };
